import type { ListingMeta } from '@/features/plp/domain/models/ProductListing';
import type { ListingMetaPresentationVm } from '@/features/plp/presentation/viewModels/plp.vm';
import { searchImageListingSeo } from '@/pages/product-listing/searchImage.seo';

export function applySearchPlpMetaPresentation(
  listingMeta: ListingMeta,
  metaPresentation: ListingMetaPresentationVm | null,
): ListingMeta {
  if (!metaPresentation) return listingMeta;
  return {
    ...listingMeta,
    header: metaPresentation.headerLabel,
    ...(metaPresentation.filtersResetUrl && { filtersResetUrl: metaPresentation.filtersResetUrl }),
    ...(metaPresentation.exploreLinks?.length && { exploreLinks: metaPresentation.exploreLinks }),
    ...(metaPresentation.listingSeo && { listingSeo: metaPresentation.listingSeo }),
  };
}

export function applyImageSearchListingSeo(
  listingMeta: ListingMeta,
  metaPresentation: ListingMetaPresentationVm | null,
): ListingMeta {
  const base = applySearchPlpMetaPresentation(listingMeta, metaPresentation);
  const listingSeo = base.listingSeo ?? searchImageListingSeo;
  return {
    ...base,
    listingSeo: {
      ...listingSeo,
      title: listingSeo.title ?? searchImageListingSeo.title,
      robotsMeta: searchImageListingSeo.robotsMeta,
    },
  };
}
